// extracted by mini-css-extract-plugin
module.exports = {"section1Container":"Section1_section1Container__fuVNL","itemContainer":"Section1_itemContainer__v_tq7","itemRow":"Section1_itemRow__NjXmd","item":"Section1_item__VtL4X"};